import React, {FC, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {calculateAndFormatTimeHHMMSS} from '../../../processes/helpers';
import LiveTimeProgressBar
  from '../../../common/time_progress_bar/LiveTimeProgressBar';
import useTimer, {
  getDatesDifferenceInSeconds
} from '../../../../hooks/useTimer';
import {AlertSettingsProps} from '../../../settings/alert_alarm/types';

type TaskViewTimerProps = {
  startedAt?: string,
  completedAt?: Nullable<string>,
  targetTime?: number,
  processAlertData: Nullable<AlertSettingsProps>
}

const TaskViewTimer: FC<TaskViewTimerProps> = ({
  startedAt,
  completedAt,
  processAlertData,
  targetTime
}) => {
  const {t} = useTranslation('tasks');
  const initialDatesDiff = useMemo(() =>
    getDatesDifferenceInSeconds(startedAt),
  [startedAt]);

  const {resultTimeHHMMSS: resultTime} = useTimer({
    initialDiff: initialDatesDiff,
    initialActive: !!startedAt
  });

  return (
    <>
      <div className="tasks-header_element">
        <p className="tasks-header_element-title">{t('diagram.header.totalTime')}</p>
        <p className="tasks-header_element-data">
          {resultTime}
        </p>
      </div>
      <LiveTimeProgressBar
        startedAt={startedAt || ''}
        completedAt={completedAt || ''}
        targetTime={targetTime || 0}
        alertSettings={processAlertData}
        isCurrentlyRunning={false}
        processExpiredTimeFormat={calculateAndFormatTimeHHMMSS}
      />
    </>
  );
};

export default TaskViewTimer;
